import {
  UseAuthenticationFlowDialogsReturnType
} from '~/src/hooks/auth/flow/useAuthenticationFlowDialogs'
import { AuthenticationFlowDialogNameEnum } from '~/src/types/DialogNameEnum'

interface ReturnsType {
  onSubmit(): Promise<void>,
}

interface Props extends Pick<UseAuthenticationFlowDialogsReturnType, 'goToStep'> {
}

const useAuthenticationFlowRegisterSuccessfulOnSubmit = ({ goToStep }: Props): ReturnsType => {
  const onSubmit = async (): Promise<void> => {
    goToStep(AuthenticationFlowDialogNameEnum.AUTHENTICATION_FLOW_LOGIN_TYPE_SELECTION)
  }

  return {
    onSubmit
  }
}

export default useAuthenticationFlowRegisterSuccessfulOnSubmit
